const branches = {
  branches: {
    pageHeader: 'Sucursales',
    addBranchOffice: '+ Añadir una sucursal',
    name: 'Nombre',
    city: 'Ciudad',
    state: 'Estado/Provincia',
    country: 'País',
    branches: 'Sucursales',
    noBranchAvailable: '** Sin sucursales disponibles **'
  }
};

export default branches;
